import { render, staticRenderFns } from "./ResetView.vue?vue&type=template&id=1d79df05&scoped=true"
import script from "./ResetView.vue?vue&type=script&lang=js"
export * from "./ResetView.vue?vue&type=script&lang=js"
import style0 from "./ResetView.vue?vue&type=style&index=0&id=1d79df05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79df05",
  null
  
)

export default component.exports